var chunkToChildrenMap = {
	"7715": [
		4610,
		6627,
		234,
		2367
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };